<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <header class="content__title pl-0">
            <h1>Packages</h1>

            <div class="actions">
                <a class="btn btn-success btn--icon" @click.prevent="showCreateDialog"
                   v-b-tooltip.left title="Add new package"><i class="zmdi zmdi-plus"></i></a>
            </div>
        </header>

        <div class="card">
            <div class="bg-primary align-items-center d-flex">
                <h5 class="card-header text-white">All Packages</h5>
            </div>
            <b-table hover stacked="md" :items="tableData" sort-by="name" :fields="table.fields" :show-empty="true">
                <template slot="price" slot-scope="data">
                    {{ data.item.price | money_format }}
                </template>

                <template slot="subscribers" slot-scope="data">
                    <span class="badge-group mr-2">
                        <span class="badge badge-secondary mb-1">Trialing</span><span class="badge badge-warning mb-1">{{ data.item.trial_subscriptions_count | number_format }}</span>
                    </span>

                    <span class="badge-group mr-2">
                        <span class="badge badge-secondary mb-1">Purchased</span><span class="badge badge-success mb-1">{{ data.item.purchased_subscriptions_count | number_format }}</span>
                    </span>
                </template>

                <template slot="description" slot-scope="data">
                    <div class="pre-line">{{ data.item.description }}</div>
                </template>

                <template slot="badges" slot-scope="data">
                    <span class="badge badge-danger" v-if="data.item.deleted_at">
                    Disabled
                    </span>
                </template>
                <template slot="actions" slot-scope="row">

                    <b-button @click="showEditDialog(row.item)"
                              variant="secondary btn--icon"
                              v-b-tooltip.hover="'Edit Package'">
                        <i class="zmdi zmdi-edit"></i>
                    </b-button>
                </template>
            </b-table>
        </div>
        <CreateModal :close="closeCreateDialog" @refresh="refetch" v-model="creating" v-if="creating" />
        <EditModal :close="closeEditDialog" :pkg="editingPackage" v-model="editingPackage" v-if="editingPackage" />
    </div>
</template>

<script>
import listPackagesQuery from '@views/Packages/Browse/queryListPackages.graphql';
import CreateModal from './CreateModal';
import EditModal from './EditModal';

export default {
  name: 'BrowsePackages',
  apollo: {
    packages: {
      query: listPackagesQuery,
      update: data => data.filterPackages,
      variables: { input: { include_deleted: true } },
    },
  },
  data() {
    return {
      packages: [],
      editingPackage: null,
      creating: false,
      loading: 0,
      table: {
        fields: [
          {
            key: 'name',
            label: 'Package',
          },
          {
            key: 'description',
            label: 'Description',
          },
          {
            key: 'price',
            label: 'Price',
          },
          {
            key: 'subscribers',
            label: 'Subscribers',
          },
          {
            key: 'badges',
            label: 'Statuses',
          },
          {
            key: 'actions',
            label: '',
            tdClass: 'text-right',
          },
        ],
      },
    };
  },
  computed: {
    tableData() {
      return (this.packages || []);
    },
  },
  methods: {
    showEditDialog(pkg) {
      this.editingPackage = pkg;
    },
    closeEditDialog() {
      this.editingPackage = null;
    },
    showCreateDialog() {
      this.creating = true;
    },
    closeCreateDialog() {
      this.creating = false;
    },
  },
  components: {
    EditModal,
    CreateModal,
  },
};
</script>
